import Downloader from 'js-file-downloader'
import { DateTime } from 'luxon'

export const ApiGsc = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const gscDomains = async () => {
    const result = await axios.get('api/shelter/gsc_domains')
    return result.data
  }

  const shelterDomainsLoad = async (account) => {
    const result = await axios.get('api/shelter/domains')
    return result.data
  }

  const shelterDomainsDetails = async (id) => {
    if (id) {
      const result = await axios.get(`api/shelter/domains/${id}`)
      return result.data
    }
  }

  const shelterDomainsDetailsBacklinks = async (id, page = 1) => {
    if (id) {
      const result = await axios.get(`api/shelter/domains/${id}/backlinks?page=${page}`)
      return result.data
    }
  }

  const shelterSetStatus = async (did, id, status) => {
    console.log(did, id, status)
    const result = await axios.get(`api/shelter/${did}/status/${id}/${status}`)
    return result.data
  }

  const shelterGsiRevoke = async (id) => {
    const result = await axios.get(`api/shelter/revoke/${id}`)
    return result.data
  }

  const shelterGenerateDisavow = async (did, filename) => {
    const token = sessionStorage.getItem('token')
    const headers = []
    headers.push(
      {
        name: 'Authorization',
        value: 'Bearer ' + token
      }
    )

    const params = {
      method: 'get',
      autoStart: false,
      headers,
      filename,
      url: `${obuBaseUrl}/api/shelter/${did}/disavow`
    }

    console.log(params)

    const download = new Downloader(params)
    return download
  }

  const shelterDomainsAdd = async (domain) => {
    const result = await axios.post('api/shelter/domains', { domain })
    return result.data
  }

  const shelterUpload = async (id, formdata) => {
    console.log('shelterUpload', id, formdata)
    axios.setHeader('Content-Type', 'multipart/form-data')
    const result = await axios.$post(`api/shelter/domains/${id}/upload`, formdata)
    return result
  }

  return {
    gscDomains,
    shelterDomainsAdd,
    shelterDomainsLoad,
    shelterDomainsDetails,
    shelterDomainsDetailsBacklinks,
    shelterGenerateDisavow,
    shelterGsiRevoke,
    shelterSetStatus,
    shelterUpload
  }
}
